module.exports = __webpack_public_path__ + "static/img/zj_teacher_num_widget_2.d4d53b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/zj_teacher_num_widget_2.png
// module id = 8BRX
// module chunks = 11